import apiClient from './api';
import { Patient } from '../types';

export const patientService = {
  // Get patient by ID
  getById: async (patientId: string): Promise<Patient> => {
    const response = await apiClient.get<Patient>(`/api/patients/${patientId}`);
    return response.data;
  },

  // Existing patients with this phone number (exact match; families may share numbers)
  findByPhone: async (phone: string): Promise<Patient[]> => {
    const response = await apiClient.get<Patient[]>('/api/patients/by-phone', { params: { phone } });
    return response.data || [];
  },

  // Search patients
  search: async (query: string): Promise<Patient[]> => {
    const response = await apiClient.get<Patient[]>('/api/patients/search', {
      params: { query },
    });
    return response.data;
  },

  // Get current user's patient profile
  getMyProfile: async (): Promise<Patient> => {
    const response = await apiClient.get<Patient>('/api/patients/me');
    return response.data;
  },

  // Create patient
  create: async (patientData: Partial<Patient>): Promise<Patient> => {
    const response = await apiClient.post<Patient>('/api/patients', patientData);
    return response.data;
  },

  // Update patient
  update: async (patientId: string, patientData: Partial<Patient>): Promise<Patient> => {
    const response = await apiClient.put<Patient>(`/api/patients/${patientId}`, patientData);
    return response.data;
  },

  // Link ABHA to patient
  linkAbha: async (patientId: string, abhaNumber: string, abhaAddress: string): Promise<Patient> => {
    const response = await apiClient.post<Patient>(`/api/patients/${patientId}/link-abha`, {
      abhaNumber,
      abhaAddress,
    });
    return response.data;
  },
};
